import { useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { debounce } from "lodash";
import Cookies from "universal-cookie";
import useGet from "../read/useGet";
import { ROLE } from "../../config";

const cookies = new Cookies();

export const useAdminPettyCashList = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const role = cookies.get(ROLE);

  const initialEmpFilters = {
    limit: 10,
    page_number: parseInt(searchParams.get("page_number")) || 0,
    search_query: searchParams.get("search_query") || "",
  };

  const [searchQuery, setSearchQuery] = useState(initialEmpFilters.search_query);

  const {
    list: employeeListing,
    paramsObject: empFilters,
    setGetListParams: setEmpFilters,
  } = useGet({
    url: "petty-cash/employee_list",
    initialData: initialEmpFilters,
    enabled: role === "COMPANY_ADMIN",
  });

  const empFiltersRef = useRef(empFilters);
  empFiltersRef.current = empFilters;

  const { list: statisticsListing } = useGet({
    url: "petty-cash/statistics",
    enabled: role === "COMPANY_ADMIN",
  });

  const handlePageClick = (val) => {
    const updated = { ...empFilters, page_number: val.selected };
    setEmpFilters(updated);
    setSearchParams(updated);
  };

  const debouncedSearch = useRef(
    debounce((value) => {
      const updated = { ...empFiltersRef.current, search_query: value, page_number: 0 };
      setEmpFilters(updated);
      setSearchParams(updated);
    }, 300)
  ).current;

  const handleEmpSearch = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    debouncedSearch(value);
  };

  return {
    employeeListing,
    statisticsListing,
    empFilters,
    searchQuery,
    handleEmpSearch,
    handlePageClick,
  };
};
